import m from 'mithril';
import { SubFsm } from 'little-fsm';
import { HotelDetail, RoomTypeResult, TemporaryRoomTypeSelection } from '../../Models';
import { AppComponents } from '../../app_common_setup';
import { HotelAndRoomSelectionSubManifest } from '../../states/app_desktop_root';
import HotelDetailsPage from '../../components/desktop/hoteldetails/HotelDetailsPage';
import RoomSearchCriteria from '../../states/RoomSearchCriteria';
import LoadingIndicator from '../../components/common/LoadingIndicator';

let roomTypeResults: RoomTypeResult[]|undefined = undefined;
let hotelDetails: HotelDetail|undefined = undefined;
let isFetchingRooms: boolean = false;

export function buildRoomSelectionPresenter(subFsm:SubFsm<HotelAndRoomSelectionSubManifest>, appComponents: AppComponents, hotelId:string): { render:() => m.Vnode} {
    let dataSource = appComponents.dataSource;
    let messageProvider = appComponents.messageProvider;
    let channel = appComponents.branding.channel;
    let pathName = window.location.pathname;
    
    if(pathName.includes('bookingsession')){
        console.log(pathName);
        console.log(pathName.substring(pathName.lastIndexOf('/') + 1))
        let sessionId = pathName.substring(pathName.lastIndexOf('/') + 1);
        dataSource.getBookingSession(sessionId).then(async bookingSessionResult => {                        
            console.log("Got Booking Session :: ", bookingSessionResult);
            dataSource.getHotelDetails(bookingSessionResult.hotel.id, bookingSessionResult.checkInDate, bookingSessionResult.checkOutDate).then(async hotelDetailsResult => {
                let roomSearchCriteria:RoomSearchCriteria= new RoomSearchCriteria(bookingSessionResult.checkInDate, bookingSessionResult.checkOutDate, 
                    bookingSessionResult.numberOfRooms, bookingSessionResult.guestType);
                roomTypeResults = await dataSource.getRoomTypeResults(sessionId);
                subFsm.processEvent('booking_session_created', {
                    searchCriteria: roomSearchCriteria,
                    bookingSession: bookingSessionResult
                }) 
                hotelDetails = hotelDetailsResult;
                isFetchingRooms = false;
            });                        
        });
    }else{
        dataSource.getHotelDetails(+hotelId).then(result => {
            console.log("Got hotel details", result);
            hotelDetails = result;
        })
    }
    

    subFsm.setEnterEffect('search_progressing', ctx => {      
        console.log(ctx)  
        dataSource.createBookingSession(channel, hotelDetails!.id, ctx.searchCriteria!).then(async bookingSession => {
            console.log("Got new booking session", bookingSession);

            let bookingSessionId = bookingSession.bookingSessionId;
            roomTypeResults = await dataSource.getRoomTypeResults(bookingSessionId);
            isFetchingRooms = false;
            subFsm.processEvent('search_succeeded', {
                bookingSession: bookingSession
            })
        });
    });

    subFsm.setEnterEffect('showing_result', ctx => {
        subFsm.processEvent('room_selection_requested', {})
        m.redraw();
    })

    subFsm.setEnterEffect('checking_out', ctx => {
        let removedRoomsIds: string[] = [];
        dataSource.updateBookingSession(ctx.bookingSession?.bookingSessionId!!, ctx.roomTypeSelections, removedRoomsIds)
            .then(updatedBookingSession => {
                console.log("Got updated booking session", updatedBookingSession);
                subFsm.processEvent('checked_out_succeed', {
                    bookingSession: updatedBookingSession
                })
            });
    })


    return {   
        render() {
            let substate = subFsm.getCurrentSubState();
            let context = subFsm.getCurrentContext();
                
            if(hotelDetails != undefined){
                return m("div.px-3", 
                    m(HotelDetailsPage,{
                        isFetchingRooms: isFetchingRooms,
                        searchCriteria : context.searchCriteria,
                        messageProvider : messageProvider,
                        hotelDetails: hotelDetails,
                        roomTypeResults: roomTypeResults,
                        selectedRoomSelections: context.roomTypeSelections,
                        attemptingBackNav: substate == 'confirming_exit_selection_complete' || substate == 'confirming_exit_selection_partial',
                        onSearchRooms: function(criteria){
                            if(context.roomTypeSelections.length > 0){
                                subFsm.processEvent('room_selection_emptied', {
                                    roomTypeSelections: [] 
                                })
                            }
                            
                            if ( criteria ){
                                isFetchingRooms = true;
                                subFsm.processEvent('search_submitted', {
                                    searchCriteria: criteria
                                })                                
                            }
                        },
                        onCheckoutRequested: (roomTypeSelections) => {                                
                            subFsm.processEvent('checked_out_requested', {
                                roomTypeSelections: roomTypeSelections
                            })                               
                        },
                        onOptionSelected: (selection:TemporaryRoomTypeSelection) => {
                            let selectedRooms = context.roomTypeSelections;
                            selectedRooms.push(selection)

                            if(context.searchCriteria!.getNumberOfRooms() == selectedRooms.length){
                                subFsm.processEvent('room_selection_completed', {
                                    roomTypeSelections: selectedRooms
                                })
                            }else{
                                subFsm.processEvent('room_selection_incompleted', {
                                    roomTypeSelections: selectedRooms 
                                });
                            }
                        },
                        onOptionRemoved: (selection:TemporaryRoomTypeSelection) => {
                            let selectedRooms = context.roomTypeSelections.filter(roomType => roomType != selection)
                            
                            if(context.roomTypeSelections.length == 1){
                                subFsm.processEvent('room_selection_emptied', {
                                    roomTypeSelections: selectedRooms 
                                })
                            }else{
                                subFsm.processEvent('room_selection_incompleted', {
                                    roomTypeSelections: selectedRooms 
                                    });
                            }
                        },
                        onChangeAttemptingBackNav: () => {
                            if(substate =='confirming_exit_selection_complete' || substate == 'confirming_exit_selection_partial'){
                                subFsm.processEvent('exit_cancelled', {})
                            }

                            if(substate == 'selection_complete' || substate == 'selection_partial'){
                                subFsm.processEvent('back', {})
                            }                                 
                        },
                        onBackPressed: () => {
                            roomTypeResults = undefined;
                            window.dispatchEvent(new CustomEvent("go-back"));

                            if(substate == 'confirming_exit_selection_complete' || substate == 'confirming_exit_selection_partial'){
                                subFsm.processEvent('exit_confirmed', {
                                    roomTypeSelections: []
                                })
                            }else{
                                subFsm.processEvent('back', {})
                            }
                        },
                    }) 
                )           
            }else{
                return m("div.m-5", 
                    m(LoadingIndicator, {colorScheme: "secondary"})
            );
            }
        }                    
    }
}